import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { GithubIssueEntity } from "@cohesive/api-entities";
import { useQuery } from "@tanstack/react-query";

interface UseGitHubIssuesSearchParams {
  connection: IntegrationConnection;
  query: string;
  enabled?: boolean;
}

export function useGitHubIssuesSearch({
  connection,
  query,
  enabled = true,
}: UseGitHubIssuesSearchParams) {
  return useQuery({
    queryKey: ["github-issues-search", connection?.id || "", query],
    queryFn: () => {
      return orgAPI.toolbox.execute<GithubIssueEntity[]>({
        integration_connection_id: connection?.id || "",
        action_name: "github-issues-and-prs-search",
        action_input: {
          query,
          type: "issues",
          max_results: 100,
        },
        // Typed issues drive the rich row UI; their generic projections ride
        // along in data_generic and are what get placed on the canvas.
        entity_format: "both",
      });
    },
    enabled: enabled && !!connection?.id && !!query,
    staleTime: 1000 * 60, // 1 minute
  });
}
